module.exports = __webpack_public_path__ + "img/log_branco_norven.aab4c298.png";